module.exports = __webpack_public_path__ + "img/collection-engagementRingsDainty.344796b.webp";